import { render, staticRenderFns } from "./dealDetailed.vue?vue&type=template&id=12fbfbf2&scoped=true"
import script from "./dealDetailed.vue?vue&type=script&lang=js"
export * from "./dealDetailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fbfbf2",
  null
  
)

export default component.exports